import React from 'react';
import { injectIntl } from 'react-intl';
import { Formik, Form } from 'formik';
// logic
import useTicketForm from './useTicketForm';
// components
//
import TicketFormContainer from '../ui/containers/ticketFormContainer';
//
import TicketFormBody from './ticketFormBody';
import { TicketFormFooter } from './ticketFormFooter';

const TicketForm = ({ ticketFormData, className }) => {
  const {
    // ticketFormSettings,
    onSubmit,
    onCancel,
    onCancelTicket,
    onMarkTicketAsDone,
    isQuoteAccepted,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isCancellable,
    isDone,
    isDraft,
    draftErrors,
    ticketDetail,
  } = ticketFormData;

  const { showErrors, setShowErrors, isWaitingForResponse, backendErrors, beforeOnSubmit } =
    useTicketForm({ onSubmit });

  return (
    <TicketFormContainer className={className}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={beforeOnSubmit()}
      >
        {({ errors, dirty, values, submitForm: submitFormikForm }) => {
          const ticketFormBodyData = {
            showErrors,
            backendErrors,
            values,
            initialValues,
            isReadOnly,
            isEdit,
            isDraft,
            draftErrors,
            ticketDetail,
          };
          const ticketFormFooterData = {
            backendErrors,
            setShowErrors,
            isWaitingForResponse,
            submitFormikForm,
            onCancel,
            onCancelTicket,
            onMarkTicketAsDone,
            isQuoteAccepted,
            isEdit,
            isDone,
            isCancellable,
            isReadOnly,
            dirty,
          };
          return (
            <Form>
              <TicketFormBody ticketFormBodyData={ticketFormBodyData} />
              <TicketFormFooter ticketFormFooterData={ticketFormFooterData} />
            </Form>
          );
        }}
      </Formik>
    </TicketFormContainer>
  );
};

export default injectIntl(TicketForm);
